window.$ = window.jQuery = require('jquery');

require('@fancyapps/fancybox')
require('slick-carousel')
require('jquery-mask-plugin');
require('jquery-match-height');
require('tablesaw/dist/tablesaw.jquery');
require('tablesaw/dist/tablesaw-init');
window.toastr = require('toastr');
require('retinajs');
require('flatpickr');
let ptBr = require('flatpickr/dist/l10n/pt.js');

jQuery(document).ready(function ($) {

    module.exports.TablesawConfig = {
        i18n: {
            swipePreviousColumn: "The column before",
            swipeNextColumn: "The column after"
        },
        swipe: {
            horizontalThreshold: 45,
            verticalThreshold: 45
        }
    };

    flatpickr(".flatpickr", {
        "locale": ptBr
    });

    $(".header-accordion").click(function () {

        $header = $(this);
        $content = $header.next();

        $header.toggleClass("expand");

        $content.slideToggle(300, function () {
            $.fn.matchHeight._update()
        });

    });

    //BANNER
    if (window.Rocket != undefined) {
        Rocket.flicker({
            selector: '.flicker',
            animation: 'transition-fade',
            autoFlick: true,
            dotAlignment: 'center',
            autoFlickDelay: '2',
            arrows: 'true'
        });
    } 
    
    $(".balao").click(function () {

        $headerSalvar = $(this);
        $content = $headerSalvar.next();

        $headerSalvar.toggleClass("expand");

        $content.slideToggle(300, function () {
            $.fn.matchHeight._update()
        });

    });

    $("table.padrao").each(function () {
        var $this = $(this),
            $contentExpand = $this.parent().find(".content");

        $this.on('click', 'span.close', function () {
            $contentExpand.slideUp();
        });
    });


    $(".meus-pedidos-detalhe").each(function () {
        var $this = $(this),
            $contentExpand = $this.parent().find(".box-expand");

        $this.on('click', '.btn-exportar', function () {
            $contentExpand.slideToggle();
        });
    });

    $(".meus-pedidos-detalhe").each(function () {
        var $this = $(this),
            $contentInteragirExpand = $this.parent().find(".box-interagir");

        $this.on('click', '.interagir-cliente', function () {
            $contentInteragirExpand.slideToggle();
        });
    });


    //AREA REPRESENTANTE
    $(".btn-expand-filtro").click(function () {
        $(".filtro-busca").toggle();
    });
    //PRODUTO DETALHE
    $('.slider-big-produto').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-thumb-produto'
    });
    $('.slider-thumb-produto').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-big-produto',
        dots: false,
        arrows: false,
        centerMode: false,
        vertical: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2,
                    vertical: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
    //MATCH HEIGHT
    $('.item').matchHeight({
        property: 'min-height'
    });
    $('.responsive').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    
    //RETINA IMAGENS
    retinajs($('img'));

    //TOASTR
    // show when page load
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "500",
        "hideDuration": "300",
        "timeOut": "4500",
        "extendedTimeOut": "4500",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }

    /*$('.btn-send').click(function () {
        toastr.success('Sucesso form!');
        toastr.error("Erros form");
    });*/

    function toggleNavigation() {
        if ($('body').hasClass('display-nav')) {
            // Close Nav
            $('body').removeClass('display-nav');
        } else {
            // Open Nav
            $('body').addClass('display-nav');
        }
    }

    //HAMBURGUERS
    var forEach = function (t, o, r) {
        if ("[object Object]" === Object.prototype.toString.call(t))
            for (var c in t) Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t);
        else
            for (var e = 0, l = t.length; l > e; e++) o.call(r, t[e], e, t)
    };
    var hamburgers = document.querySelectorAll(".hamburger");
    if (hamburgers.length > 0) {
        forEach(hamburgers, function (hamburger) {
            hamburger.addEventListener("click", function () {
                this.classList.toggle("is-active");
            }, false);
        });
    }
    $(function () {
        $('.hamburger').click(function () {
            toggleNavigation();
        });
    });
    //MASKINPUTS
    (function () {
        var TelefoneMaskBehavior = function (val) {
                return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            },
            TelefoneMaskOptions = {
                onKeyPress: function (val, e, field, options) {
                    field.mask(TelefoneMaskBehavior.apply({}, arguments), options);
                }
            };

        $('[name=telefone],[name=celular]').mask(TelefoneMaskBehavior, TelefoneMaskOptions);
        $('[name=cpf]').mask('999.999.999-99');
    })();
    //SELECT
    (function () {
        $('select.custom').each(function () {
            var title = $(this).attr('title');
            title = $('option:selected', this).text();
            if (title === undefined) {
                title = '';
            }
            $(this).css({
                'z-index': 10,
                'opacity': 0,
                '-khtml-appearance': 'none'
            }).after('<span class="custom-span">' + title + '</span>').change(function () {
                val = $('option:selected', this).text();
                $(this).next().text(val);
            });
        });
    })();
});
